import { ref } from 'vue'

/**
 * Header bell unread total. The inbox and the shell do not share a list:
 * marking read or evaluating stays on `/notifications`, so the route watcher
 * never refetches. Bump this after a committed reminder write.
 */
export const reminderBadgeRevision = ref(0)

/** Visible-tab poll. The reminder worker writes on its own interval and there is no push channel. */
export const UNREAD_BADGE_POLL_MS = 60_000

export function bumpReminderBadge() {
  reminderBadgeRevision.value += 1
}
